module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAABAElEQVR4Ae3WEUwFUABA0QdBGIRBviBf0JYvyCnIF+QU5AtyCvKF+YJ8QRiEQXBz621v+9XOcbtyx6YBAAAAAAC0YQIIIMDvIYAAAggggAACCCCAAAIIIADVRXNuB+tUL805GKxRnTTncbBO9dCc08Ea1X711c+9VluDNaqb5lwO1qi2q49+7rPaGVhP64n1tJ5YT+uJ9bSe/In1pDpuztNgneq+OWeDNaq9yfV8s54LVdfNuRosXc/3yfXcHaxRnTfnbrBO9dycw8Ea1VHW03rOs55YT+uJ9bSeWE/rSRsmgAAC/GMCCCCAAAIIIIAAAggggAACAAAAAAAAAAAAfAOYO2aLYhhMYwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/italic-white-icon.png
// module id = 319
// module chunks = 0